var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"vin-loading-block"}},[_c('div',{staticClass:"bg-black opacity-25 absolute inset-0 flex items-center rounded-lg"},[(_vm.hasSpinner)?_c('VinLoading',{staticClass:"mx-auto"}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }